///
/// EarthBrowser
///
/// Created by Matt Giger on 9/18/2026
/// Copyright (c) 2026 Geodata Labs
///

import { useAppSelector } from "@/redux/store"
import { syncPlacemarks } from "@/redux/placemarksSync"
import { useEffect } from "react"

/**
 * Triggers placemarks delta syncs: on app start when already signed in,
 * on sign-in (anonymous local placemarks get pushed up), and on regained
 * connectivity. Individual mutations push live via the store listener;
 * this covers everything those pushes could have missed.
 */
export function usePlacemarksSync() {
	const userId = useAppSelector(state => state.user.userProfile?.id)

	useEffect(() => {
		if (userId === undefined) return

		void syncPlacemarks()

		const onOnline = () => { void syncPlacemarks() }
		window.addEventListener("online", onOnline)
		return () => window.removeEventListener("online", onOnline)
	}, [userId])
}
